import { render, staticRenderFns } from "./AvatarCard.vue?vue&type=template&id=748bcbb3&scoped=true&"
import script from "./AvatarCard.vue?vue&type=script&lang=js&"
export * from "./AvatarCard.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCard.vue?vue&type=style&index=0&id=748bcbb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748bcbb3",
  null
  
)

export default component.exports